import { KeyValueMap } from "../../components";
import { Spanish } from "../../languages";

// TRANSFORMACIÓN DEL ARCHIVO JSON DEL ESPAÑOL PARA QUE SIRVAN COMO TIPOS
// NOTA: Los demás archivos json de los otros idiomas, todos deben tener las mismas claves que el archivo principal: Español (es.json)
type DeepType<T> = {
  [K in keyof T]: T[K] extends KeyValueMap ? DeepType<T[K]> : any;
};

// Aplica al JSON importado
export type LanguageType = "es" | "en";
export enum LanguageEnum {
  SET = "language/set",
}

// CADA KEY DEL JSON DE ESPAÑOL SE ASOCIAN EN "t"
export type LanguageState = DeepType<typeof Spanish>;
export interface LanguageProps {
  t: LanguageState;
  currentLanguage: LanguageType;
}
export interface LanguageDispatchProps extends LanguageProps {
  dispatch: React.Dispatch<any>;
}
